import { render } from "./mobile-task-publish.vue?vue&type=template&id=48ccaa52&scoped=true"
import script from "./mobile-task-publish.vue?vue&type=script&lang=js"
export * from "./mobile-task-publish.vue?vue&type=script&lang=js"

import "./mobile-task-publish.vue?vue&type=style&index=0&id=48ccaa52&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ccaa52"]])

export default __exports__